module.exports = __webpack_public_path__ + "static/media/leprechauns_loot.6ae1f624.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/leprechauns_loot.png
// module id = 317
// module chunks = 0